export default __webpack_public_path__ + "static/media/Directory.de4eea91.svg";